/**
 * @generated SignedSource<<28d8e4e0bd544e5bf584aedeac27794b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OverrideSyncStatusForUserEventMutationInput = {
  clientMutationId?: string | null;
  externalEventId: string;
};
export type OverrideSyncStatusForUserEventMutation$variables = {
  input: OverrideSyncStatusForUserEventMutationInput;
};
export type OverrideSyncStatusForUserEventMutation$data = {
  readonly overrideSyncStatusForUserEvent: {
    readonly clientMutationId: string | null;
  } | null;
};
export type OverrideSyncStatusForUserEventMutation = {
  variables: OverrideSyncStatusForUserEventMutation$variables;
  response: OverrideSyncStatusForUserEventMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "OverrideSyncStatusForUserEventMutationPayload",
    "kind": "LinkedField",
    "name": "overrideSyncStatusForUserEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OverrideSyncStatusForUserEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OverrideSyncStatusForUserEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d169d9a4de5b56e4af22e0999f34726",
    "id": null,
    "metadata": {},
    "name": "OverrideSyncStatusForUserEventMutation",
    "operationKind": "mutation",
    "text": "mutation OverrideSyncStatusForUserEventMutation(\n  $input: OverrideSyncStatusForUserEventMutationInput!\n) {\n  overrideSyncStatusForUserEvent(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "db7a5ed750c04f51ea20de98af5e30cd";

export default node;
